
import { Component, Vue, Prop } from 'vue-property-decorator';
import MoreFilmsSlide from './MoreFilmsSlide.vue';
import FilmsPromoPosterSlide from '../Home/FilmsPromoPosterSlide.vue';
import PromoList from '~/components/Sanity/PromoList.vue';

@Component({
  components: {
    FilmsPromoPosterSlide,
    MoreFilmsSlide,
    PromoList,
  },
})
export default class MoreFilmsCarousel extends Vue {
  @Prop(Boolean) readonly isOrderConfirmation!: boolean;
  @Prop(String) readonly title!: string;
  @Prop({ type: Boolean, default: false }) readonly portraitMode!: boolean;

  get slideWidth() {
    return this.portraitMode ? 375 : 282;
  }

  get aspectRatio() {
    return this.portraitMode ? 75 / 106 : 16 / 9;
  }
}
